import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ReactGA from 'react-ga4';

import AnalyticsTracker from './components/AnalyticsTracker'; 
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import PrivateRoute from './components/PrivateRoute'; // Correctly import PrivateRoute

// Import all your pages
import Home from './pages/Home';
import Signup from './pages/Signup';
import Login from './pages/Login';
import Submit from './pages/Submit';
import EditPost from './pages/EditPost';
import PostPage from './pages/PostPage';
import FraudMatrixPage from './pages/FraudMatrixPage';
import AdminMatrixPage from './pages/AdminMatrixPage';
import AnalyticsPage from './pages/AnalyticsPage';
import LearnMorePage from './pages/LearnMorePage';
import LandingPage from './pages/LandingPage';
import UserProfilePage from './pages/UserProfilePage';
import DisclaimerPage from './pages/DisclaimerPage'; 
import ResearchingProjectsPage from './pages/learning/ResearchingProjectsPage';
import SpottingScamsPage from './pages/learning/SpottingScamsPage';
import PigButcheringPage from './pages/learning/PigButcheringPage';
import OnChainAnalysisPage from './pages/learning/OnChainAnalysisPage';
import ArticlePage from './pages/learning/ArticlePage';
import AdminLearningPage from './pages/AdminLearningPage';
import AdminEditArticlePage from './pages/AdminEditArticlePage';
import VerificationDashboard from './pages/VerificationDashboard';
import ApplyVerifierPage from './pages/ApplyVerifierPage';
import ScamMapPage from './pages/ScamMapPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';

const GA_MEASUREMENT_ID = "G-8B15G4K0D5"; 
ReactGA.initialize(GA_MEASUREMENT_ID)

const AppLayout = ({ children }) => (
    <div className="flex-grow container mx-auto px-4 pt-20">
        <div className="lg:grid lg:grid-cols-12 lg:gap-6">
            <main className="lg:col-span-8 xl:col-span-9 mb-8 lg:mb-0">
                {children}
            </main>
            <aside className="lg:col-span-4 xl:col-span-3">
                <Sidebar />
            </aside>
        </div>
    </div>
);

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <AnalyticsTracker />
          <div className="min-h-screen flex flex-col">
            <div className="gradient-bg"></div>
            <div className="grid-pattern"></div>
            <Navbar />
          <Routes>  
            <Route path="/" element={<AppLayout><LandingPage /></AppLayout>} />
            <Route path="/post/:postId" element={<AppLayout><PostPage /></AppLayout>} />
            <Route path="/matrix" element={<AppLayout><FraudMatrixPage /></AppLayout>} />
            <Route path="/disclaimer" element={<AppLayout><DisclaimerPage /></AppLayout>} /> 
            <Route path="/login" element={<AppLayout><Login /></AppLayout>} />
            <Route path="/signup" element={<AppLayout><Signup /></AppLayout>} />
            <Route path="/home" element={<AppLayout><PrivateRoute><Home /></PrivateRoute></AppLayout>} />
            <Route path="/profile/:userId" element={<AppLayout><PrivateRoute><UserProfilePage /></PrivateRoute></AppLayout>} />
            <Route path="/submit" element={<AppLayout><PrivateRoute><Submit /></PrivateRoute></AppLayout>} />
            <Route path="/edit-post/:postId" element={<AppLayout><PrivateRoute><EditPost /></PrivateRoute></AppLayout>} />
            <Route path="/analytics" element={<AppLayout><PrivateRoute><AnalyticsPage /></PrivateRoute></AppLayout>} />
            <Route path="/learn" element={<AppLayout><LearnMorePage /></AppLayout>} />
            <Route path="/learn/researching-projects" element={<AppLayout><ResearchingProjectsPage /></AppLayout>} />
            <Route path="/learn/spotting-scams" element={<AppLayout><SpottingScamsPage /></AppLayout>} />
            <Route path="/learn/pig-butchering" element={<AppLayout><PigButcheringPage /></AppLayout>} />
            <Route path="/learn/on-chain-analysis" element={<AppLayout><OnChainAnalysisPage /></AppLayout>} />
            <Route path="/learn/:slug" element={<AppLayout><ArticlePage /></AppLayout>} />
            <Route path="/admin/matrix" element={<AppLayout><PrivateRoute><AdminMatrixPage /></PrivateRoute></AppLayout>} />
            <Route path="/admin/learning" element={<AppLayout><PrivateRoute><AdminLearningPage /></PrivateRoute></AppLayout>} />
            <Route path="/admin/learning/edit/:articleId" element={<AppLayout><PrivateRoute><AdminEditArticlePage /></PrivateRoute></AppLayout>} />
            <Route path="/admin/learning/new" element={<AppLayout><PrivateRoute><AdminEditArticlePage /></PrivateRoute></AppLayout>} />
            <Route path="/verify" element={<AppLayout><PrivateRoute><VerificationDashboard /></PrivateRoute></AppLayout>} />
            <Route path="/apply-verifier" element={<AppLayout><PrivateRoute><ApplyVerifierPage /></PrivateRoute></AppLayout>} />
            <Route path="/map" element={<AppLayout><ScamMapPage /></AppLayout>} />
            <Route path="/forgot-password" element={<AppLayout><ForgotPasswordPage /></AppLayout>} />
          </Routes>
        </div>
      </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
